var React = require('react');

function Arrow (props) {
    return React.createElement("svg",props,React.createElement("g",{"stroke":"#ff4628","strokeWidth":"1.2"},[React.createElement("path",{"d":"m1.20007 10.8 9.60003-9.60005","key":0}),React.createElement("path",{"d":"m2.80005 1.19995h7.99995v8","key":1})]));
}

Arrow.defaultProps = {"fill":"none","height":"12","viewBox":"0 0 12 12","width":"12"};

module.exports = Arrow;

Arrow.default = Arrow;
